import { EventBus } from "./EventBus";

export const GlobalEventBus = new EventBus();
